document.body.classList.add('loading');

// Remove loading class once page fully loads
window.addEventListener('load', function () {
    document.body.classList.remove('loading');
});

document.addEventListener("DOMContentLoaded", (event) => {
    if (window.publish !== undefined && window.subscribe !== undefined && PUB_SUB_EVENTS?.cartUpdate !== undefined) {
        window.subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
            removeAddOns();
        });
    }

    // Remove addons after loading Cart page
    removeAddOns();
});

function removeAddOns() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            let changes = [];

            cart.items.forEach(item => {
                // Remove `Acrylic Tag` if there is no matching addon
                if (item.properties && item.properties['Acrylic Tag']) {
                    const orderGroup = item.properties['_io_order_group'];

                    // Look for a matching addon product in cart with the same property value
                    let addonExists = cart.items.some(addon => {
                        return addon.handle === 'acrylic-gift-tag' &&
                            addon.properties &&
                            addon.properties['_io_field_name'] === "Acrylic Tag" &&
                            addon.properties['_io_parent_order_group'] === orderGroup
                    });

                    if (!addonExists) {
                        let newProps = { ...item.properties };
                        delete newProps['Acrylic Tag'];

                        changes.push({
                            id: item.key,
                            quantity: item.quantity,
                            properties: newProps
                        });
                    }
                }

                // Remove `Charm` if there is no matching addon
                if (item.properties && item.properties['Charm']) {
                    const orderGroup = item.properties['_io_order_group'];

                    // Look for a matching addon product in cart with the same property value
                    let addonExists = cart.items.some(addon => {
                        return addon.handle === 'oventure-gold-charm' &&
                            addon.properties &&
                            addon.properties['_io_field_name'] === "Charm" &&
                            addon.properties['_io_parent_order_group'] === orderGroup
                    });

                    if (!addonExists) {
                        let newProps = { ...item.properties };
                        delete newProps['Charm'];

                        changes.push({
                            id: item.key,
                            quantity: item.quantity,
                            properties: newProps
                        });
                    }
                }
            });

            // Process each change one by one
            function applyChanges(index = 0) {
                if (index >= changes.length) {
                    if (changes.length > 0) location.reload(); // reload after last change
                    return;
                }

                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(changes[index])
                }).then(() => applyChanges(index + 1));
            }

            applyChanges();
        });
}